import React, { useState, useRef } from "react";
import JoditEditor from "jodit-react";
import axios from "axios";

const AddServiceMirai = () => {
  const editor = useRef(null); // Reference for Jodit Editor
  const [content, setContent] = useState(""); // Rich text content
  const [service, setService] = useState(""); // Service name

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate fields before submission
    if (!service.trim() || !content.trim()) {
      alert("Both service name and details are required.");
      return;
    }

    // Create the payload
    const newServiceData = {
      service: service.trim(),
      content: content.trim(), // Rich text content
      createdAt: new Date(), // Add a timestamp
    };

    try {
      // Make API call to submit the data
      const response = await axios.post(
        "https://mirai-server.vercel.app/jod/upload-service-data",
        newServiceData
      );

      // Handle success
      alert(response.data.message || "Service added successfully!");
      setService(""); // Reset service field
      setContent(""); // Reset editor content
    } catch (error) {
      // Handle error
      console.error("Error submitting service data:", error);
      alert("Failed to submit service data. Please try again.");
    }
  };

  return (
    <div className="bg-gray-100 min-h-screen">
      <h1 className="w-full bg-white px-6 py-8 shadow-lg text-4xl font-mono">
        Add New Service
      </h1>
      <form className="p-5 m-6 bg-white shadow-lg" onSubmit={handleSubmit}>
        {/* Service Name Field */}
        <div className="flex flex-col gap-3">
          <label className="text-xl font-mono text gray-900" htmlFor="service">
            Service Name:
          </label>
          <input
            type="text"
            id="service"
            value={service}
            onChange={(e) => setService(e.target.value)}
            placeholder="Enter service name"
            className="text-xl font-mono text gray-900 border border-gray-900 w-[60%]"
            required
          />
        </div>

        {/* Rich Text Editor */}
        <div className="flex flex-col gap-3 mt-5">
          <label className="text-xl font-mono text gray-900">
            Service Details:
          </label>
          <JoditEditor
            ref={editor}
            value={content}
            onBlur={(newContent) => setContent(newContent)} // Update state on editor blur
            onChange={(newContent) => setContent(newContent)} // Fallback for real-time changes
          />
        </div>

        {/* Submit Button */}
        <button
          className="bg-gray-900 px-4 py-4 text-white text-xl font-mono"
          type="submit"
          style={{ marginTop: "20px" }}
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default AddServiceMirai;
